import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
  { path: '', title: 'Iniciar sesión', component: LoginComponent },
  {
    path: 'forgot-password',
    title: 'Recuperar contraseña',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset',
    title: 'Restablecer contraseña',
    component: ResetPasswordComponent,
  },
  {
    path: 'registro',
    title: 'Registro',
    loadComponent: () =>
      import('./registro/registro.component').then((m) => m.RegistroComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
